import type { DatasetsMutatorUpdateProps } from "./datasets-mutator-update.type";

import DatasetsMutatorUpdateDataset from "../datasets-mutator-update-dataset";
import { useDatasetMutatorGetUpdateItems } from "../datasets-mutator.hook";

const DatasetsMutatorUpdate = ({
  invalidateKeys,
}: DatasetsMutatorUpdateProps) => {
  const { items, hasItems } = useDatasetMutatorGetUpdateItems();

  if (!hasItems) return null;

  return items.map((item) => (
    <DatasetsMutatorUpdateDataset
      key={item.mutationKey}
      mutatorItem={item}
      invalidateKeys={invalidateKeys}
    />
  ));
};

export default DatasetsMutatorUpdate;
